import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

export function serializeRequest(request) {
  let headers = ['Content-Type', 'Authorization'].reduce((a, x) => {
    if (request.headers.get(x)) {
      a[x] = request.headers.get(x);
    }

    return a;
  }, {});

  return {
    url: request.url,
    method: request.method,
    body: request.body,
    params: request.params.keys().reduce((a, x) => {
      a[x] = request.params.get(x);
      return a;
    }, {}),
    headers
  };
}

export function serializeResponse(response) {
  return {
    body: response.body,
    status: response.status,
    statusText: response.statusText,
    url: response.url
    // headers?: HttpHeaders; // TODO serialize headers
  };
}

export function serializeError(error) {
  return {
    error: error.error,
    status: error.status,
    statusText: error.statusText,
    url: error.url
    // headers?: HttpHeaders; // TODO serialize headers
  };
}

export function mapHttpResponseByMock(mock) {
  if (mock.error) {
    throw new HttpErrorResponse({
      error: mock.error.error,
      // headers?: HttpHeaders;  // TODO handle headers
      status: mock.error.status,
      statusText: mock.error.statusText,
      url: mock.error.url
    });
  } else {
    return new HttpResponse({
      body: mock.response.body,
      // headers: new HttpHeaders(mock.response.headers), // TODO handle headers
      status: mock.response.status,
      statusText: mock.response.statusText,
      url: mock.response.url
    });
  }
}
